<template>
  <div class="balance-user">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title" v-if="name == 0">{{ $t("head.withdrawal") }}</div>
      <div class="title" v-else>{{ $t("head.commission") }}</div>
      <!-- <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" /> -->
      <div class="record">
        <span v-if="name == 0" @click="withdrawalrecord">{{ $t("head.withdrawalRecord") }}</span>
      </div>
    </div>
    <div style="padding: 0 0.9375rem">
      <div class="exchange-number">
        <div class="left-title">{{ $t("withdrawal.commission") }}</div>
        <van-cell-group inset style="margin: 0">
          <van-field v-model="price" :placeholder="tips1" :disabled="true" />
        </van-cell-group>
        <div class="select-icon">
          <p @click="openIconShow">{{ value }}</p>
          <van-icon @click="openIconShow" name="arrow-down" size="24" color="#ffffff" />
          <div class="select-up" v-if="iconShow == true">
            <div @click="changeValue('USDT')">
              <p :class="value == 'USDT' ? 'active' : ''">USDT</p>
              <van-icon name="success" size="24" color="#000000" v-if="value == 'USDT'" />
            </div>
            <div @click="changeValue('TRX')">
              <p :class="value == 'TRX' ? 'active' : ''">TRX</p>
              <van-icon name="success" size="24" color="#000000" v-if="value == 'TRX'" />
            </div>
          </div>
        </div>
      </div>
      <div class="exchange-number">
        <div class="left-title">{{ $t("withdrawal.withdrawal_number") }}</div>
        <van-cell-group inset style="margin: 0; width: 90%">
          <van-field v-model="accountnumber" :placeholder="tips1" />
        </van-cell-group>
      </div>
      <div class="exchange-number">
        <div class="left-title">{{ $t("withdrawal.money_address") }}</div>
        <el-select style="width: 90%" v-model="addressvalue" :placeholder="tips2">
          <el-option v-for="item in addressoptions" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="brokerage">{{ $t("withdrawal.poundage") }}：{{ feeRatio || 0 }}%</div>
      <div class="nowLogin">
        <div @click="immediately">
          <p>{{ $t("withdrawal.immediately") }}</p>
        </div>
      </div>
      <div class="prompt">
        <img src="../../static/ts.png" alt="" />
        <div>
          {{ $t("withdrawal.Warm_prompt") }}：<p v-html="articleDetails"></p>
        </div>
      </div>
    </div>
    <van-overlay :show="passwordShow" @click="passwordShow = false">
      <div class="passwordShow-wrapper" @click.stop>
        <div class="block">
          <div class="index-view-top">
            <van-icon @click="passwordShow = false" name="cross" size="22" color="#565656" />
            <div class="title" style="font-size: 1rem">{{ $t("withdrawal.input_password") }}</div>
            <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
          </div>
          <div class="block-details">{{ name == 0 ? $t("head.withdrawal") : $t("head.commission") }}</div>
          <div class="block-number">
            <p>{{ accountnumber }}</p>
            <p>{{ value }}</p>
          </div>
          <div>
            <van-password-input :value="passwordValue" :gutter="10" @focus="showKeyboard = true" />
          </div>
        </div>
      </div>
    </van-overlay>
    <van-number-keyboard maxlength="6" v-model="passwordValue" :show="showKeyboard" @blur="showKeyboard = false"
      @input="onInput" />
  </div>
</template>

<script>
import { withdrawPage, bindWallet, withdrawCoin, article, info } from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: 'USDT'
        },
        {
          value: 'TRX'
        }
      ],
      passwordValue: '', //密码
      passwordShow: false,
      showKeyboard: false,
      value: 'USDT',
      account: '',
      name: '', //0:提现   1：佣金提现
      withdrawPagelist: '',
      addressvalue: '',
      addressoptions: [],
      accountnumber: '',
      articleDetails: '', //提现提示
      userInfo: '',
      tips1: this.$t('withdrawal.number'),
      tips2: this.$t('withdrawal.addressvalue'),
      iconShow: false,
      feeRatio: '',
      price: ''
    }
  },
  created() {
    this.name = this.$route.query.name
  },
  mounted() {
    this.withdrawPage(this.value)
    this.bindWallet()
    this.getArticle()
  },
  methods: {
    openIconShow() {
      this.iconShow = !this.iconShow
    },
    changeValue(item) {
      this.value = item
      this.iconShow = false
      this.withdrawPage(item)
    },
    //提现提示
    getArticle() {
      info().then(res => {
        if (res.code == '200') {
          this.userInfo = res.data
        }
      })
      article({ type: 'TIPS_WITHDRAW' }).then(res => {
        if (res.code == '200') {
          this.articleDetails = res.data.content
        }
      })
    },
    onInput(e) {
      if (this.passwordValue == '') {
        this.passwordValue = e.toString()
      }
      this.passwordValue += e.toString()
      if (this.passwordValue.length == 6) {
        this.withdrawCoin()
      }
    },
    withdrawCoin() {
      withdrawCoin({
        toAddress: this.addressvalue,
        coin: this.value,
        type: this.name,
        price: this.accountnumber,
        payPassword: this.passwordValue
      }).then(res => {
        if (res.code == '200') {
          console.log(res)
          this.$toast.success(this.$t('phone.caozuo'))
        } else {
          this.$toast(res.msg)
        }
        this.passwordValue = ''
        this.accountnumber = ''
        this.addressvalue = ''
        this.passwordShow = false
        this.showKeyboard = false
        this.withdrawPage(this.value)
      })
    },
    bindWallet() {
      bindWallet().then(res => {
        if (res.code == '200') {
          this.addressoptions = res.data
        }
      })
    },
    withdrawPage(e) {
      withdrawPage({
        coin: e,
        type: this.name
      }).then(res => {
        if (res.code == '200') {
          this.withdrawPagelist = res.data
          this.price = res.data.price
          this.feeRatio = res.data.feeRatio
        }
      })
    },
    immediately() {
      if (this.userInfo.payPwdStatus == '1') {
        this.$router.push('/withdrawal?name=' + name)
      } else {
        this.$router.push('/login?type=pay')
      }
      if (this.accountnumber == '') {
        this.$toast(this.$t('prompt.input_number'))
      } else if (this.addressvalue == '') {
        this.$toast(this.$t('prompt.addressvalue'))
      } else if (this.accountnumber >= this.withdrawPagelist.price) {
        this.$toast(this.$t('phone.buzu'))
      } else {
        this.passwordShow = true
        this.showKeyboard = true
      }
    },
    withdrawalrecord() {
      this.$router.push('/withdrawalrecord')
    },
    toBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style>
.el-select-dropdown {
  border: unset;
  background: unset;
  left: 0;
}

.el-select-dropdown__item.selected {
  background: #161414 !important;
}

.el-scrollbar {
  width: calc(100vw - 1.875rem);
  background: #161414;
  margin: 0 0.9375rem;
  border: unset;
}
</style>
<style lang="scss" scoped>
/deep/.van-password-input__security li {
  width: 2.3125rem;
  height: 2.3125rem;
  background: rgba(255, 196, 0, 0.1);
  border-radius: 0.3125rem;
}

.passwordShow-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 1.875rem;

  .block {
    width: 100%;
    height: 11.0625rem;
    background: #161414;
    border-radius: 0.9375rem;

    .block-details {
      font-size: 0.75rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }

    .block-number {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 0.625rem 0 1rem;

      >p:nth-child(1) {
        font-size: 1.125rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffc400;
      }

      >p:nth-child(2) {
        font-size: 0.6875rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #565656;
      }
    }
  }
}

/deep/.el-select {
  width: 5.5rem;

  .el-input__inner {
    background: #161414;
    border: unset !important;
    padding: 0 1.5rem 0 0.25rem;
    color: #999999;
  }
}

.balance-user {
  width: 100vw;
  height: 100vh;
  background: #0c0b0b;

  .brokerage {
    font-size: 0.75rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
    text-align: right;
    padding: 0.9375rem 0 3.125rem;
  }

  .prompt {
    display: flex;
    padding: 2.375rem 0 0 0;

    >img {
      display: block;
      width: 1rem;
      height: 1rem;
      margin-right: 0.125rem;
    }

    >div {
      font-size: 0.8125rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 1.4375rem;
      overflow: hidden;
      width: 100%;
      white-space: normal;
      word-break: break-all;
    }
  }

  .nowLogin {
    padding: 0 1.875rem;
    margin-bottom: 0.9375rem;

    >div {
      width: 100%;
      height: 2.6875rem;
      background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
      border-radius: 1.375rem;
      display: flex;
      align-items: center;
      justify-content: center;

      >p {
        font-size: 0.9375rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #0c0b0b;
      }
    }
  }

  .exchange-number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.25rem;
    height: 2.6875rem;
    background: #161414;
    margin-top: 0.9375rem;

    .select-icon {
      display: flex;
      align-items: center;
      padding-right: 1rem;
      position: relative;

      .select-up {
        position: absolute;
        z-index: 999;
        top: 40px;
        right: 1rem;
        width: 16rem;
        background: #ffffff;
        border-radius: 0.5rem;
        padding: 0.5rem 0;

        .active {
          color: #409eff !important;
        }

        >div {
          padding: 0.5rem 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      >p {
        width: 48px;
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }

    .left-title {
      width: 10%;
      padding-left: 0.75rem;
      min-width: 5rem;
      max-width: 5rem;
      font-size: 0.8125rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: unset;
  }

  /deep/ .van-field__control {
    color: #ffffff !important;
  }

  .van-cell {
    background: #161414;
    //border-radius: 1.375rem;
  }

  .van-cell-group {
    background: #161414;
    border-radius: 1.375rem;
    color: #ffffff;
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .record {
      font-size: 0.9375rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
    }

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/user/withdrawal.vue